
const state = {
  menuLists:localStorage.getItem('menuLists') ? JSON.parse(localStorage.getItem('menuLists')) : [],
  footerLists:localStorage.getItem('footerLists') ? JSON.parse(localStorage.getItem('footerLists')) : [],
  device: 'desktop',
}

const mutations = {
  SET_MENU_LISTS: (state, data) => {
    localStorage.setItem('menuLists',JSON.stringify(data))
    state.menuLists = data
  },
  SET_FOOTER_LISTS: (state, data) => {
    var filterData = data.filter((item) => item.code != 'INDEX')
    localStorage.setItem('footerLists',JSON.stringify(filterData))
    state.footerLists = data
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  
}

const actions = {
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setMenuLists({ commit }, data) {
    commit('SET_MENU_LISTS', data)
  },
  setFooterLists({commit}, data) {
    commit('SET_FOOTER_LISTS',data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
